import { create } from 'zustand'
import {
	fetchNotifications,
	markNotificationRead,
	markAllNotificationsRead
} from '../api/notification'
import { Notification } from '../helpers/types/notification'

export interface NotificationState {
	notifications: Notification[]
	unreadCount: number
	total: number
	isFetched: boolean

	fetchNotifications: (page?: number, limit?: number) => Promise<void>
	prependNotification: (notification: Notification) => void
	markRead: (id: string) => Promise<void>
	markAllRead: () => Promise<void>
}

export const notificationStore = create<NotificationState>((set, get) => ({
	notifications: [],
	unreadCount: 0,
	total: 0,
	isFetched: false,

	fetchNotifications: async (page = 1, limit = 20) => {
		const res = await fetchNotifications(page, limit)
		set({
			notifications: res.notifications,
			unreadCount: res.unreadCount,
			total: res.total,
			isFetched: true
		})
	},

	prependNotification: (notification: Notification) => {
		set((state) => ({
			notifications: [notification, ...state.notifications],
			unreadCount: state.unreadCount + 1,
			total: state.total + 1
		}))
	},

	markRead: async (id: string) => {
		await markNotificationRead(id)
		set((state) => {
			const wasUnread = state.notifications.some(
				(n) => n.id === id && !n.isRead
			)
			return {
				notifications: state.notifications.map((n) =>
					n.id === id ? { ...n, isRead: true } : n
				),
				unreadCount: wasUnread
					? Math.max(0, state.unreadCount - 1)
					: state.unreadCount
			}
		})
	},

	markAllRead: async () => {
		await markAllNotificationsRead()
		set((state) => ({
			notifications: state.notifications.map((n) => ({
				...n,
				isRead: true
			})),
			unreadCount: 0
		}))
	}
}))
